module.exports = __webpack_public_path__ + "static/media/bell.0f0a63d5.png";